import React from 'react';
import { Link }           from 'react-router-dom';
import Header             from '../components/Header';
import ScheduleCalendar   from '../components/ScheduleCalendar';
import './SchedulePage.scss'; // optional styling

export default function SchedulePage() {
  return (
    <>
      <Header />
      <div className="schedule-page">
        <Link to="/" className="back-button">← Back</Link>
        <h2>Your Full Schedule</h2>
        <ScheduleCalendar />
      </div>
    </>
  );
}
